(ns manatee.components.modal.db
  (:require [medley.core :refer [dissoc-in]]))

(def root [:visible-modal])
(def modal-props-path (conj root [:modal-props]))

(defn hide
  [db modal-id]
  (dissoc-in db (conj root modal-id)))

(defn show
  [db modal-id]
  (-> db
      (dissoc-in root)
      (assoc-in (conj root modal-id) true)))

(defn visible?
  [db modal-id]
  (boolean (get-in db (conj root modal-id))))

(defn modal-props
  [db]
  (get-in db modal-props-path))

(defn set-modal-props
  [db modal-props]
  (assoc-in db modal-props-path modal-props))
